module.exports = __webpack_public_path__ + "assets/img/mr4.e3b09710.png";